module.exports = __webpack_public_path__ + "img/4.58d24366.jpg";